import { gql } from "@apollo/client";

export interface IConnectLinkInfo {
  valid: boolean;
  channel?: string;
  email?: string;
}

export interface IGetConnectLinkInfoVars {
  token: string;
}

export const GET_CONNECT_LINK_INFO = gql`
  query getConnectLinkInfo($token: String!) {
    getConnectLinkInfo(token: $token) {
      valid
      channel
      email
    }
  }
`;
